import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AppCardList } from '../../../../../common/components';
import { AppRoutes } from '../../../../../common/interfaces';
import { DomainRegistrar } from '../../../entities';

interface Props {
  currentPage: number;
  domainRegistrarsListItems: DomainRegistrar[];
  domainRegistrarsListTotalItems: number;
  domainRegistrarsListItemsPerPage: number;
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const DomainRegistrarsListView: FC<Props> = ({
  currentPage,
  domainRegistrarsListItems,
  domainRegistrarsListTotalItems,
  domainRegistrarsListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  const navigate = useNavigate();
  const domainRegistrarId = useParams()['*'];

  return (
    <AppCardList<DomainRegistrar>
      headerTitle={ null }
      pagination={{
        current: currentPage,
        total: domainRegistrarsListTotalItems,
        pageSize: domainRegistrarsListItemsPerPage,
        disabled: isLoading,
        onChange: (page: number) => handleChangePage(page)
      }}
      selectedKey={ domainRegistrarId }
      rowKey="id"
      titleKey="name"
      grid={{
        gutter: 16,
        xs: 1,
        sm: 1,
        md: 1,
        lg: 2,
        xl: 2,
        xxl: 3
      }}
      navigateTo={ (record) => ({ to: AppRoutes.DomainRegistrarsById.replace(':domainRegistrarId', record.id) }) }
      list={ domainRegistrarsListItems }
    />
  );
};
